import styled from "styled-components";
import theme from "../../Styles/theme";

export const Container = styled.div`

    display: flex;
    align-items:center;
    justify-content:center;
    flex-direction: column;

`;


export const Button = styled.button`
width:60%;
background-color: ${theme.colors.darkGrey};
border-radius: 0.25rem;
padding: 1vh 2vw;
font-size: max(8px, 1vw);
margin-bottom:2vh;
color: ${theme.colors.light};
display: flex;
align-items: center;
justify-content:center;
`;